<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="false"
    :formsConfig="formsConfig"
    ref="gc-base-layout"
    class="help-layout"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="'Help'" />
    </template>

    <div class="content-body">
      <span class="title">Hot Keys</span>
      <div class="hot-key-data">
        <dx-data-grid
          :columns="getColumns"
          :data-source="getDataSource"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{
            visible: false,
          }"
          :searchPanel="{
            visible: false,
          }"
          :repaint-changes-only="true"
        >
        </dx-data-grid>
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
export default {
  mixins: [RouteMixin, FormMixin],
  computed: {
    getColumns() {
      return [
        {
          caption: "Definition",
          dataField: "Definition",
        },
        {
          caption: "Windows Combination",
          dataField: "Windows",
        },
        {
          caption: "Mac Combination",
          dataField: "Mac",
        },
      ];
    },
    getDataSource() {
      return [
        {
          Definition: "Save changes or commit transaction",
          Windows: "Ctrl + S / F9",
          Mac: "Command + S / F9",
        },
        {
          Definition: "Navigate to first option in filter panel",
          Windows: "Ctrl + F / F2",
          Mac: "Command + F / F2",
        },
        {
          Definition: "New record",
          Windows: "Alt + N",
          Mac: "Option + N",
        },
        {
          Definition: "Engage edit",
          Windows: "Ctrl + E",
          Mac: "Command + E",
        },
        {
          Definition: "Dismiss context menu / modal / screen",
          Windows: "Esc",
          Mac: "Esc",
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.help-layout {
  .content {
    padding: 12px;
    .content-body {
      background-color: white;
      padding: inherit;
      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .hot-key-data {
        padding-top: 12px;
      }
    }
  }
}
</style>